/* tslint:disable:max-line-length */
import { DefaultMessages, SegmentSpecificMessages } from '@sheerid/jslib';

type ExtendedMessages = {
    step: {
        personalInfo: {
            title: string,
        },
        success: {
            title: string,
            subtitle: string,
        },
        docUpload: {
            title: string,
            subtitle: string,
        },
    },
};

export const employeeMessagesEN: DefaultMessages & SegmentSpecificMessages & ExtendedMessages = {
    birthDate: 'Date of birth',
    branchOfService: 'Branch of service',
    changeLanguage: 'Change language',
    country: 'Country',
    countries: {
        AD: 'Andorra',
        AE: 'United Arab Emirates',
        AF: 'Afghanistan',
        AG: 'Antigua and Barbuda',
        AI: 'Anguilla',
        AL: 'Albania',
        AM: 'Armenia',
        AN: 'Netherlands Antilles',
        AO: 'Angola',
        AR: 'Argentina',
        AS: 'American Samoa',
        AT: 'Austria',
        AU: 'Australia',
        AW: 'Aruba',
        AZ: 'Azerbaijan',
        BA: 'Bosnia-Herzegovina',
        BB: 'Barbados',
        BD: 'Bangladesh',
        BE: 'Belgium',
        BF: 'Burkina Faso',
        BG: 'Bulgaria',
        BH: 'Bahrain',
        BI: 'Burundi',
        BJ: 'Benin',
        BM: 'Bermuda',
        BN: 'Brunei Darussalam',
        BO: 'Bolivia',
        BR: 'Brazil',
        BS: 'Bahamas',
        BT: 'Bhutan',
        BV: 'Bouvet Island',
        BW: 'Botswana',
        BY: 'Belarus',
        BZ: 'Belize',
        CA: 'Canada (exclues Québec)',
        CF: 'Central African Republic',
        CG: 'Congo',
        CH: 'Switzerland',
        CI: 'Ivory Coast (Cote D\'Ivoire)',
        CK: 'Cook Islands',
        CL: 'Chile',
        CM: 'Cameroon',
        CN: 'China',
        CO: 'Colombia',
        CR: 'Costa Rica',
        CU: 'Cuba',
        CV: 'Cape Verde',
        CY: 'Cyprus',
        CZ: 'Czech Republic',
        DE: 'Germany',
        DJ: 'Djibouti',
        DK: 'Denmark',
        DM: 'Dominica',
        DO: 'Dominican Republic',
        DZ: 'Algeria',
        EC: 'Ecuador',
        EE: 'Estonia',
        EG: 'Egypt',
        EH: 'Western Sahara',
        ER: 'Eritrea',
        ES: 'Spain',
        ET: 'Ethiopia',
        FI: 'Finland',
        FJ: 'Fiji',
        FK: 'Falkland Islands',
        FM: 'Micronesia',
        FO: 'Faroe Islands',
        FR: 'France',
        GA: 'Gabon',
        GB: 'United Kingdom',
        GD: 'Grenada',
        GE: 'Georgia',
        GF: 'French Guyana',
        GH: 'Ghana',
        GI: 'Gibraltar',
        GL: 'Greenland',
        GM: 'Gambia',
        GN: 'Guinea',
        GP: 'Guadeloupe (French)',
        GQ: 'Equatorial Guinea',
        GR: 'Greece',
        GS: 'South Georgia & South Sandwich Islands',
        GT: 'Guatemala',
        GU: 'Guam (USA)',
        GW: 'Guinea Bissau',
        GY: 'Guyana',
        HK: 'Hong Kong',
        HM: 'Heard and McDonald Islands',
        HN: 'Honduras',
        HR: 'Croatia',
        HT: 'Haiti',
        HU: 'Hungary',
        ID: 'Indonesia',
        IE: 'Ireland',
        IL: 'Israel',
        IN: 'India',
        IO: 'British Indian Ocean Territory',
        IQ: 'Iraq',
        IR: 'Iran',
        IS: 'Iceland',
        IT: 'Italy',
        JM: 'Jamaica',
        JO: 'Jordan',
        JP: 'Japan',
        KE: 'Kenya',
        KG: 'Kyrgyzstan',
        KH: 'Cambodia',
        KI: 'Kiribati',
        KM: 'Comoros',
        KN: 'Saint Kitts & Nevis Anguilla',
        KP: 'North Korea',
        KR: 'South Korea',
        KW: 'Kuwait',
        KY: 'Cayman Islands',
        KZ: 'Kazakhstan',
        LA: 'Laos',
        LB: 'Lebanon',
        LC: 'Saint Lucia',
        LI: 'Liechtenstein',
        LK: 'Sri Lanka',
        LR: 'Liberia',
        LS: 'Lesotho',
        LT: 'Lithuania',
        LU: 'Luxembourg',
        LV: 'Latvia',
        LY: 'Libya',
        MA: 'Morocco',
        MC: 'Monaco',
        MD: 'Moldavia',
        ME: 'Montenegro',
        MG: 'Madagascar',
        MH: 'Marshall Islands',
        MK: 'Macedonia',
        ML: 'Mali',
        MM: 'Myanmar',
        MN: 'Mongolia',
        MO: 'Macau',
        MP: 'Northern Mariana Islands',
        MQ: 'Martinique (French)',
        MR: 'Mauritania',
        MS: 'Montserrat',
        MT: 'Malta',
        MU: 'Mauritius',
        MV: 'Maldives',
        MW: 'Malawi',
        MX: 'Mexico',
        MY: 'Malaysia',
        MZ: 'Mozambique',
        NA: 'Namibia',
        NC: 'New Caledonia (French)',
        NE: 'Niger',
        NF: 'Norfolk Island',
        NG: 'Nigeria',
        NI: 'Nicaragua',
        NL: 'Netherlands',
        NO: 'Norway',
        NP: 'Nepal',
        NR: 'Nauru',
        NU: 'Niue',
        NZ: 'New Zealand',
        OM: 'Oman',
        PA: 'Panama',
        PE: 'Peru',
        PF: 'Polynesia (French)',
        PG: 'Papua New Guinea',
        PH: 'Philippines',
        PK: 'Pakistan',
        PL: 'Poland',
        PM: 'Saint Pierre and Miquelon',
        PN: 'Pitcairn Island',
        PR: 'Puerto Rico',
        PT: 'Portugal',
        PW: 'Palau',
        PY: 'Paraguay',
        QA: 'Qatar',
        RE: 'Reunion (French)',
        RO: 'Romania',
        RS: 'Serbia',
        RU: 'Russian Federation',
        RW: 'Rwanda',
        SA: 'Saudi Arabia',
        SB: 'Solomon Islands',
        SC: 'Seychelles',
        SD: 'Sudan',
        SE: 'Sweden',
        SG: 'Singapore',
        SH: 'Saint Helena',
        SI: 'Slovenia',
        SK: 'Slovak Republic',
        SL: 'Sierra Leone',
        SM: 'San Marino',
        SN: 'Senegal',
        SO: 'Somalia',
        SR: 'Suriname',
        ST: 'Saint Tome (Sao Tome) and Principe',
        SV: 'El Salvador',
        SY: 'Syria',
        SZ: 'Swaziland',
        TC: 'Turks and Caicos Islands',
        TD: 'Chad',
        TF: 'French Southern Territories',
        TG: 'Togo',
        TH: 'Thailand',
        TJ: 'Tajikistan',
        TK: 'Tokelau',
        TM: 'Turkmenistan',
        TN: 'Tunisia',
        TO: 'Tonga',
        TR: 'Turkey',
        TT: 'Trinidad and Tobago',
        TV: 'Tuvalu',
        TW: 'Taiwan',
        TZ: 'Tanzania',
        UA: 'Ukraine',
        UG: 'Uganda',
        UM: 'USA Minor Outlying Islands',
        US: 'United States',
        UY: 'Uruguay',
        UZ: 'Uzbekistan',
        VA: 'Vatican City State',
        VC: 'Saint Vincent & Grenadines',
        VE: 'Venezuela',
        VG: 'Virgin Islands (British)',
        VI: 'Virgin Islands (USA)',
        VN: 'Vietnam',
        VU: 'Vanuatu',
        WF: 'Wallis and Futuna Islands',
        WS: 'Samoa',
        XK: 'Kosovo',
        YE: 'Yemen',
        YT: 'Mayotte',
        ZA: 'South Africa',
        ZM: 'Zambia',
        ZW: 'Zimbabwe',
    },
    dateTime: {
        january: 'January',
        february: 'February',
        march: 'March',
        april: 'April',
        may: 'May',
        june: 'June',
        july: 'July',
        august: 'August',
        september: 'September',
        october: 'October',
        november: 'November',
        december: 'December',
        month: 'Month',
        day: 'Day',
        year: 'Year',
        '20_MIN': '20 minutes',
        '2_MIN': '2 minutes',
        '2_HOURS': '2 hours',
        '24_HOURS': '24 hours',
        '3_DAY': '3 days',
        A_FEW_MINUTES: 'a few minutes',
        A_FEW_HOURS: 'a few hours',
        A_FEW_DAYS: 'a few days',
    },
    dischargeDate: 'Discharge date',
    emailAddress: 'Email address',
    address: 'Mailing Address',
    emailExplanation: 'Needed to send you your unique code',
    schoolName: '', // N/A
    phoneNumber: 'Mobile Number',
    error: 'Error',
    limitExceededError: 'Verification Limit Exceeded',
    firstName: 'First name',
    howDoesReviewWork: 'How does review work?',
    howDoesVerifyingWork: 'How does verifying work?',
    informationTransferredToUS: 'Your information will be transferred to the United States and will be treated according to SheerID’s privacy policy.',
    lastName: 'Last name',
    loading: 'Loading...',
    locales: {
        ar: 'Arabic',
        bg: 'Bulgarian',
        cs: 'Czech',
        da: 'Danish',
        de: 'German',
        el: 'Greek',
        'en-GB': 'English (UK)',
        'en-US': 'English',
        'es-ES': 'Spanish (Spain)',
        es: 'Spanish',
        fi: 'Finnish',
        'fr-CA': 'French (Canadian)',
        fr: 'French',
        hr: 'Croatian',
        hu: 'Hungarian',
        id: 'Indonesian',
        is: 'Icelandic',
        it: 'Italian',
        iw: 'Hebrew',
        ja: 'Japanese',
        ko: 'Korean',
        lt: 'Lithuanian',
        ms: 'Malay',
        nl: 'Dutch',
        no: 'Norwegian',
        pl: 'Polish',
        'pt-BR': 'Portuguese (Brazil)',
        pt: 'Portuguese',
        ro: 'Romanian',
        ru: 'Russia',
        sk: 'Slovak',
        sl: 'Slovenian',
        sr: 'Serbian',
        sv: 'Swedish',
        tr: 'Turkish',
        'zh-HK': 'Chinese (Hong Kong)',
        zh: 'Chinese (Traditional)',
    },
    militaryStatus: 'Military status',
    noOptions: 'No options',
    personalInformation: 'Personal Information',
    personalOrSchoolIsFine: 'Personal or school email is fine',
    postalCode: 'Postal code',
    poweredBy: 'Verification services powered by SheerID',
    requiredFields: 'All fields are required',
    school: 'School',
    sheeridFaqs: 'SheerID FAQs',
    studentInfoShared: 'Information entered into this web form will be used for verification purposes. The information will be shared with {companyName}. ',
    universityName: 'University name',
    verifyAndContinue: 'Verify and continue',
    verificationPurposesOnly: 'Used for verification purposes only',
    verifyMyStudentStatus: 'Verify My Student Status',
    verifyMyTeacherStatus: 'Verify My Teacher Status',
    verifyMyMilitaryStatus: 'Verify My Military Status',
    verifyMyMedicalProfessionalStatus: 'Verify My Medical Professional Status',
    verifyMyEmploymentStatus: 'SUBMIT FOR REVIEW',
    status: 'Status',
    VETERAN: 'Veteran',
    MILITARY_RETIREE: 'Military Retiree',
    RESERVIST: 'Reservist',
    ACTIVE_DUTY: 'Active Duty',
    MILITARY_FAMILY: 'Registered Military Dependent',
    FIREFIGHTER: 'Firefighter',
    POLICE: 'Police',
    EMT: 'EMT',
    organization: 'Organization',
    verifyMyFirstResponderStatus: 'Verify My First Responder Status',
    firstResponderInfoShared: 'Information entered here will be used for verification purposes',
    militaryInfoShared: 'Information entered here will be used for verification purposes.',
    employmentInfoShared: 'Information entered here will be used for verification purposes and will be shared with {companyName}. By clicking Submit, you agree to sign up for {companyName} email marketing. You can unsubscribe at any time.',
    tryAgain: 'Try again',
    errorId: {
        fraudRulesReject: 'We\'re glad you\'re enthusiastic, but it looks like you\'ve already redeemed or attempted to redeem this offer.',
        internalServerError: 'Internal server error',
        noProgram: 'No program found',
        noVerification: 'No verification found',
        expiredProgram: 'This link is no longer active',
        invalidProgram: 'Invalid program',
        invalidStep: 'Invalid step',
        invalidMilitaryStatus: 'Invalid military status',
        invalidFirstResponderStatus: 'Invalid first responder status',
        invalidOrganization: 'You must select an organization from the list',
        invalidFirstName: 'Invalid first name',
        invalidLastName: 'Invalid last name',
        invalidMemberId: 'Invalid ID Number',
        invalidBirthDate: 'Invalid birth date',
        invalidEmail: 'Invalid email',
        invalidPhoneNumber: 'Invalid mobile number',
        invalidCountry: 'Invalid country',
        invalidPostalCode: 'Invalid postal code',
        invalidAddress: 'Invalid address',
        invalidCity: 'Invalid city',
        invalidState: 'Invalid state',
        invalidSocialSecurityNumber: 'Invalid SSN',
        underagePerson: 'Persons under age 16 are not eligible for this offer.',
        outsideAgePerson: 'Birthdate is not eligible for this offer.',
        futureBirthDate: 'Future birthdate',
        unsupportedDocMimeType: 'One or more files is an unsupported format',
        invalidFileSizeEmpty: 'One or more files is empty',
        invalidFileSizeMax: 'One or more files is too large (max: 10MB)',
        invalidNumberOfFiles: 'Maximum number of files exceeded (max: 5)',
        invalidDocUploadToken: 'Provided document upload token is not valid',
        verificationLimitExceeded: 'We\'re glad you\'re enthusiastic, but it looks like you\'ve already redeemed or attempted to redeem this offer.',
        apiRateLimitExceeded: 'Unable to process your request at this time, please try again later',
        docReviewLimitExceeded: 'Document review limit exceeded',
        maxMetadataValuesExceeded: 'Maximum number of metadata values exceeded',
        maxMetadataLengthExceeded: 'Maximum length of metadata value exceeded',
        unknownError: 'Unknown Error',
        invalidRequest: 'Invalid request',
        invalidApiToken: 'Provided API token was invalid or empty',
        simulatedError: 'This is a simulated error',
        notFound: 'Not found',
        unauthorizedDomain: 'Unauthorized domain',
        noRemainingRewardCodes: "Sorry, this offer is currently closed and we can't verify you at this time. Please try again later.",
    },
    step: {
        personalInfo: {
            title: 'Verify your details',
            subtitle: 'Complete the form below to confirm your eligibility.',
            howDoesVerifyingWorkDetails: `"{companyName} has set up this special offer for all current employees of select companies.
            <br><br>
            {companyName} uses SheerID, a trusted partner, to verify that you are currently employed. SheerID only collects information that assists in verifying your eligibility. Additional information or documentation may be requested.`,
            tryAgain: {
                title: 'Check the information that you have provided',
                subtitle: 'The information you have provided should match your official documents.',
            },
        },
        docUpload: {
            title: 'We need some more info',
            subtitle: 'Documents will be reviewed in {estimatedWaitTime} by staff at SheerID, a trusted partner.',
            acceptableUploadExamples: 'Acceptable examples include:',
            acceptedTypes: 'File must be .jpg .jpeg .png .pdf .gif or .bmp',
            addFile: 'Add file',
            cancelButtonLabel: 'Cancel',
            fileInstructions: 'CHOOSE FILE',
            footer: '',
            submitButtonLabel: 'Continue',
            rejectedSubtitle: 'We were unable to confirm your eligibility due to:',
            howDoesVerifyingWorkDetails: `Document review is handled by SheerID, a trusted partner who specializes in verifying employees.
            <br><br>
            Documents are used only for verify your employment status is current and will be permanently deleted after review is finalized. They will not be shared with {companyName}`,
            uploadInstructions: 'Upload an official document that shows',
            rejectionReasons: {
                DOCUMENT_UNREADABLE: 'The document you submitted was unreadable due to poor image quality. Please make sure you have a clearly legible image that\'s bright and crisp, and try submitting again.',
                DOCUMENT_PASSWORD_PROTECTED: 'We are unable to accept password protected documents.',
                DOCUMENT_LIKELY_FRAUD: 'The document you submitted is insufficient for establishing eligibility for this offer.',
                DOCUMENT_UNSUPPORTED: 'The document you submitted is not on the list of accepted document types.',
                DOCUMENT_HANDWRITTEN: 'We cannot accept handwritten documents.',
                MISSING_INFORMATION: 'The document you submitted does not provide all of the information necessary to determine eligibility for this offer.',
                MISSING_INFORMATION_PERSON_NAME: 'The document you submitted is missing a first and/or last name.',
                MISSING_INFORMATION_ORGANIZATION_NAME: 'The document you submitted does not include an organization name that confirms your connection to that organization.',
                DOCUMENT_EXPIRED: 'The document you submitted has expired.',
                DOCUMENT_OUTDATED: 'The document you submitted is missing an issue date or was issued too far in the past.',
                MISMATCH_PERSON_NAME: 'The information on the document you submitted does not match the first and/or last name submitted on the verification form.',
                MISMATCH_ORGANIZATION: 'The organization name on the document(s) you submitted does not match the organization you listed on the verification form.',
                MISMATCH_STATUS: 'The status on the document you submitted does not match the status you listed on your verification form.',
                INELIGIBLE_ORGANIZATION: 'The organization on the document you submitted is not eligible for this offer.',
                MISSING_INFORMATION_UNIVERSITY_ENROLLMENT: 'The document you submitted does not prove enrollment in the current term.',
                INELIGIBLE_PERSON_HIGH_SCHOOL_STUDENT: 'High School Students are not eligible for this offer.',
                MISSING_INFORMATION_AFFILIATION_US_ARMED_FORCES: 'The document you submitted is does not show affiliation to an eligible branch of the United States Armed Forces.',
                MISMATCH_COMPANY_NAME_OR_ADDRESS: 'The company name or address in your document does not match what you entered on the verification form.',
                PAYSTUB_OUTDATED_LAST_30_DAYS: 'Please upload a paystub that was issued within the last 30 days.',
                MISSING_INFORMATION_BIRTHDATE: 'The document you submitted is missing a birthdate, or your age is ineligible for this offer.',
                MISMATCH_BIRTHDATE: 'The birthdate on the document you submitted does not match the birthdate you listed on the verification form.',
                DOCUMENT_OUTDATED_FACULTY: 'The document you submitted does not prove employment in the current academic year.',
                MISSING_OR_MISMATCH_JOB_TITLE: 'The job title on the document you submitted is missing or does not match what you entered on the verification form.',
                OTHER_CONTACT_US: 'We are having problems verifying your eligibility for the offer. Please contact SheerID customer service for help: customerservice@sheerid.com',
                PERSON_FIELD_MISMATCH: 'A field in the document provided did not match with what was provided on the verification form.',
            },
            uploadInfo: {
                fullName: 'Your full name',
                student: {
                    enrollmentDate: 'Date proving enrollment for the current term (or within the last 3 months)',
                    school: 'Your school',
                },
                teacher: {
                    currentSchoolYear: 'A date in the current school year',
                    school: 'Your school',
                },
                military: {
                    currentAffiliation: 'Your current affiliation with the armed services',
                    dischargeDate: 'Your discharge date (if applicable)',
                    serviceBranch: 'Your branch of service',
                    uploadInstructionsDependent: 'Please upload a document that clearly shows your first name, last name, valid dates and status',
                },
                senior: {
                    birthDate: 'Your date of birth',
                },
                age: {
                    birthDate: 'Your date of birth',
                },
                firstResponder: {
                    currentAffiliation: 'Your current affiliation with that organization',
                    organization: 'Your organization',
                },
                medical: {
                    status: 'Your medical professional status',
                    validDate: 'A currently valid date',
                },
                employment: {
                    company: 'Your company',
                    currentAffiliation: 'Your current affiliation with that company',
                },
            },
            acceptableUploads: {
                student: {
                    idCard: 'School ID card with expiration date',
                    classSchedule: 'Class schedule',
                    tuitionReceipt: 'Tuition receipt',
                },
                teacher: {
                    idCard: 'Teacher ID card with valid date',
                    payStub: 'Pay stub from within last 60 days',
                },
                member: {
                    idCard: 'Membership Document',
                    payStub: 'Pay stub from within last 90 days',
                },
                senior: {
                    birthCertificate: 'Your birth certificate',
                    driversLicense: 'Your drivers license',
                    passport: 'Your passport',
                    stateId: 'Your state-issued ID',
                },
                age: {
                    birthCertificate: 'Your birth certificate',
                    driversLicense: 'Your drivers license',
                    passport: 'Your passport',
                    stateId: 'Your state-issued ID',
                },
                military: {
                    activeDuty: 'Any document that proves you are currently serving under Title 10 Active Duty Orders for 30 days or more',
                    veteran: 'Any document that proves you met the qualifications of military service and were honorably discharged',
                    reservistA: 'Any document that shows you are currently serving in the National Guard or a Reserve Component of The United States Armed Forces',
                    retiree: 'Any document that proves you are a Retiree from the US Armed Forces',
                    dependent: 'Any document that proves you are a Registered Military Dependent',
                },
                medical: {
                    licenseCertificate: 'Certificate of license',
                    idCard: 'Nursing ID card with expiration date',
                    photoPayStub: 'Photo ID and recent Pay Stub',
                },
                employment: {
                    employeeIdCard: 'Employee ID Card',
                    payStub: 'Pay stub from within last 60 days',
                    officialLetter: 'An official letter',
                },
                firstResponder: {
                    idCard: 'ID Card',
                    payStub: 'Pay stub from within last 60 days',
                    letter: 'An official letter',
                },
            },
        },
        pending: {
            titleCountdown: 'Processing',
            titleReview: 'Reviewing',
            subtitle: 'SheerID is reviewing your documents, to confirm your status. This process may take up to {maxReviewTime}.',
            subtitle2: ' ',
            subtitle3: 'You will be contacted via email.',
            subtitleCountdown: 'Hang tight while we upload and scan your documents.',
        },
        success: {
            title: 'Success',
            subtitle: "You've been verified. Below is your single-use coupon code. Your single-use coupon code can be used during checkout on <a className='sid-blue-link' href='https://purple.com/mattresses' target='_blank'>purple.com</a>. The coupon cannot be combined with any other offer or promotion.",
            copyCouponCode: 'Copy Coupon code',
            emailNotification: "Please return to <a href='https://www.purple.com/?utm_medium=em&utm_source=shid&utm_content=email&utm_campaign=43802&utm_term=pt&c3ch=Email&c3nid=shidsorry' >purple.com</a> to continue shopping. <br><br>We're also emailing you a copy of your code so that you can shop now, or shop later. Please check for an email from verify@sheerid.com for details.",
            verificationOnly: `
                SheerID handles verification only.
                Now that you've been approved, please direct all questions about the
                promotion terms and/or code use to {companyName} customer service.
            `,
        },
        sso: {
            title: 'Verify using your company-provided email credentials',
            subtitle: "Please sign in to your company's email portal. It will open in a new tab.",
            subtitle2: "Can't sign in to your email?",
            login: 'Sign in to my email',
            cancel: 'Upload proof of employment',
        },
        collectSocialSecurityNumber: {
            title: 'Enter your social security number',
            useSsn: 'Verify using your social security number',
            uploadDoc: 'Upload a document',
            selectOption: 'Select an option',
            uploadInstead: 'Upload a document instead',
        },
        smsLoop: {
            titleWithNumber: "We've sent an SMS message to the mobile number ending in {number}. Enter your code here.",
            titleWithoutNumber: "We've sent an SMS to your mobile number. Please enter the code here.",
            verificationCode: 'Verification Code',
            errors: {
                codeVerification: 'Verification code could not be validated.',
                codeExpired: 'Verification code could not be validated.',
                codeResendLimit: 'Maximum number of re-tries has been reached.',
                resend: 'Error sending the SMS message',
            },
            successResend: 'SMS message re-sent successfully',
            incorrectNumber: {
                incorrectNumber1: 'Incorrect number? Click ',
                incorrectNumber2: 'here ',
                incorrectNumber3: 'to return to {companyName}',
            },
            resendButton: 'Re-send',
            submitButton: 'Submit',
        },
    },
};
